import { getLoggedInUserAllSubscriptionsByTypeV2 } from '@engage/api-v2';
import { getPrimarySubscription } from '@engage/api-v2/primary-subscription';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var toSubscriptionsFetchers = function toSubscriptionsFetchers(client) {
  return {
    GetPrimarySubscription: toFetcher(function () {
      return "GetPrimarySubscription";
    }, function () {
      return unwrap(function () {
        return getPrimarySubscription(client);
      });
    })
  };
};
export var toSubscriptionV2Fetchers = function toSubscriptionV2Fetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    GetLoggedInUserAllSubscriptionsByType: toFetcher(function () {
      return 'GetLoggedInUserAllSubscriptionsByTypeV2';
    }, function () {
      return unwrap(function () {
        return getLoggedInUserAllSubscriptionsByTypeV2(api);
      });
    })
  };
};